var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 20,
    viewBox: "0 0 56 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0271 4.23423H47.2793V6.48649H49.982V16.036H52.3244V6.48649H55.0271V4.23423ZM39.3514 4.23423H37.2793V16.036H39.6217V8.82883L44.2163 16.036H46.2883V4.23423H43.946V11.4414L39.3514 4.23423ZM36.0181 4.23423H29.8919V0H29.4415V20H29.8919V16.036H36.0181V13.7838H30.6127V11.2613H35.2073V9.00901H30.6127V6.48649H36.0181V4.23423ZM18.991 4.23423H11.2433V16.036H18.991V13.7838H13.6757V11.2613H18.2703V9.00901H13.6757V6.48649H18.991V4.23423ZM3.13518 4.23423H0.973022V16.036H3.31536V8.82883L7.90996 16.036H9.98203V4.23423H7.63969V11.4414L3.13518 4.23423ZM27.8199 4.23423H20.0721V6.48649H22.7748V16.036H25.1172V6.48649H27.8199V4.23423Z",
    fill: "rgba(var(--provider-icon-color))"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetent);
export default __webpack_public_path__ + "static/media/netent.a9882bc6d90e090efac8e558943c1d42.svg";
export { ForwardRef as ReactComponent };